import { type FC } from 'react';
import { MiniMap as ReactFlowMiniMap } from 'reactflow';
import { NodeType, NODE_TYPE_COLORS } from '@/types/node.types';
import type { NodeData } from '@/types/node.types';

function getNodeColor(node: { data?: NodeData }): string {
  if (node.data?.type) {
    return NODE_TYPE_COLORS[node.data.type as NodeType] || '#6B7280';
  }
  return '#6B7280';
}

interface MiniMapProps {
  style?: React.CSSProperties;
}

export const MiniMap: FC<MiniMapProps> = ({ style }) => {
  return (
    <ReactFlowMiniMap
      nodeColor={getNodeColor}
      maskColor="rgba(15, 23, 42, 0.7)"
      style={{
        backgroundColor: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        borderRadius: 8,
        ...style,
      }}
      pannable
      zoomable
    />
  );
};

export default MiniMap;
